import { render, staticRenderFns } from "./MobileSimTrading.vue?vue&type=template&id=fd58d868&scoped=true"
import script from "./MobileSimTrading.vue?vue&type=script&lang=js"
export * from "./MobileSimTrading.vue?vue&type=script&lang=js"
import style0 from "./MobileSimTrading.vue?vue&type=style&index=0&id=fd58d868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd58d868",
  null
  
)

export default component.exports